<template>
  <div>
    <div v-if="caseFiles(value) && caseFiles(value).length > 0" class="case-files border-bottom shadow-sm">
      <div
        class="row no-gutters list"
        v-for="file in caseFiles(value)"
        :key="file.id"
      >
        <div class="col item item-last">
          <a
            class="py-2 px-3 text-truncate"
            target="_blank"
            :href="
              `${staticUrl}/api/patient-cases/${value}/files/${file.id}/${file.name}?token=${authToken}`
            "
          >
            <file-icon></file-icon>
            {{ file.name }}
          </a>
        </div>
      </div>
    </div>
    <div v-else class="alert alert-secondary mt-3">
      {{ $t('nofiles') }}
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import FileIcon from '@/components/Icons/File'
export default {
  components: {
    FileIcon
  },
  props: {
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      staticUrl: 'app/staticUrl',
      authToken: 'auth/token',
      caseFiles: 'pcase/files'
    })
  }
}
</script>
<style lang="scss">
.case-files {
  .file-select {
    background-color: #eee !important;
    input[type="file"] {
      display: none;
    }
  }
}
</style>
<i18n>
{
  "ka": {
    "file": "ფაილი",
    "delete": "წაშლა",
    "save": "ატვირთვა",
    "selectedFile": "არჩეული ფაილი",
    "selectFile": "აირჩიე ფაილი",
    "nofiles": "არცერთი ფაილი არ არის მიმაგრებული"
  },
  "en": {
      "file": "File",
      "delete": "Delete",
      "save": "Upload",
      "selectedFile": "Seleted File",
      "selectFile": "Select File"
  }
}
</i18n>
